<div class="blog-top">
  <div class="container top-title">
    <div class="title">Başvuru Sorgulama</div>
    <div class="b-title">
      <div class="slogan">Vize Başvuru Sürecinizi öğrenin</div>
    </div>
  </div>
</div>
<div class="row-div">
  <div class="container">
    <div class="inter">
      <div class="service-item wow fadeInUp col-12 col-md-9">
        <div class="icon-box">
          <img src="../../../assets/vectors/icon-services-6.svg" alt="" />
        </div>
        <div class="service-content">
          <h3>Başvuru Sorgulama</h3>
          <p class="description">Vize başvurunuzun durumunu öğrenmek için başvuru numaranızı, TCKN veya pasaport numaranızı girin.</p>
          <div class="inquiry-form">
            <div class="form-group" style="display: flex; flex-direction: column">
              <input class="form-control" [maxlength]="maxLength" (input)="check($event)" [(ngModel)]="param" type="text" placeholder="Başvuru numarası, TC, Pasaport No" />
            </div>
            <button type="button" (click)="getVisaDetails()">Sorgula</button>
          </div>
        </div>
        <div class="service-content">
          <!-- result -->
          <div *ngIf="isResult">
            <div class="result-message">
              <div class="result-content mb-5 mt-5">
                <p class="fa"><i class="fa fa-check"></i></p>
                <p>
                  Sayın
                  <span>{{ contactPerson.firstName + " " + contactPerson.lastName }}</span>
                </p>
                <p style="font-weight: 700; font-size: 25px">Başvurunuzun Durumu: {{ status }}</p>
              </div>
            </div>
          </div>
          <!-- error result -->
          <div *ngIf="isResult == false">
            <div class="result-message">
              <div class="result-content mb-5 mt-5">
                <p class="fa"><i class="fa fa-times" style="color: red"></i></p>
                <p style="font-weight: 700; font-size: 25px">Başvuru Bulunamadı</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
